import React from 'react';

import Text from 'scouting-ui/lib/Text';

import styles from './MemberTypeTag.module.scss';

type MemberTypeValue = 'youth' | 'adult' | 'parent' | 'leader' | 'participant';

interface MemberTypeTagProps {
  memberType: MemberTypeValue;
}

const LABELS: Record<MemberTypeValue, string> = {
  youth: 'Youth',
  adult: 'Adult',
  parent: 'Parent',
  leader: 'Leader',
  participant: 'P 18+',
};

export default function MemberTypeTag({ memberType }: MemberTypeTagProps) {
  return (
    <span className={`${styles.memberTypeTag} ${styles[memberType]}`}>
      <Text font="body-overline">{LABELS[memberType]}</Text>
    </span>
  );
}
